import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { DetailedEntityActionService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-action.service';

import { InventoryReplenishDataEditorService } from './inventory-replenish-data-editor.service';
import { InventoryReplenishBackendService } from './inventory-replenish-backend.service';
import { InventoryReplenishDataService } from './inventory-replenish-data.service';
import { SearchParams } from '../../../../shared/search/models/search-params.model';

import { SearchEvent } from '../../../../shared/search/models/search-event';

import { NEW_SEARCH_EVENT } from '../../../../shared/search/search-constants';
import { InventoryReplenishButtonService } from './inventory-replenish-button.service';

@Injectable()
export class InventoryReplenishActionService extends DetailedEntityActionService {


  protected backendService: InventoryReplenishBackendService;
  protected dataEditor: InventoryReplenishDataEditorService;
  protected dataService: InventoryReplenishDataService;
  protected buttonService: InventoryReplenishButtonService;



  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);

    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = 'invreplenishtd';
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;


  }
  public onFacitityChange(facility) {
    const request = {
      'storerKey': this.dataService.primaryDataMap['storerKey'].cVal,
      'facility': facility.newVal
    };
    this.backendService.fetchdropdownGroup(request).subscribe((res: any) => {
      this.dataService.groupDropdownValues = [];
      this.dataService.groupDropdownValues = res;
      this.dataService.groupDropdownValues.unshift({ key: 'All', value: 'All' });
      this.dataService.primaryDataMap['replenishGroup'].cVal = this.dataService.groupDropdownValues[0].key;
    });
  }

  public onStorerChange(storer: any) {
    // LFWM-3641- rebuilding the button array.
    this.buttonService.dynamicButtonsExist = false;
    this.buttonService.initializeButtonsForPage(this.dataService.primaryDataMap, 'search');
    const request = {
      'storerKey': storer,
      'facility': this.dataService.primaryDataMap['facility'].cVal
    };
    this.backendService.fetchdropdownGroup(request).subscribe((res: any) => {
      this.dataService.groupDropdownValues = res;
      this.dataService.groupDropdownValues.unshift({ key: 'All', value: 'All' });
      this.dataService.primaryDataMap['replenishGroup'].cVal = this.dataService.groupDropdownValues[0].key;

    });
  }


  public onTypeChange(storer: any) {
    const request = {
      'storerKey': storer,
      'facility': this.dataService.primaryDataMap['facility'].cVal
    };
    this.backendService.fetchdropdownReplenishmentType(request).subscribe((res: any) => {
      this.dataService.groupDropdownValues = res;
    });
  }
  public getStrategy() {
    const request = {};
    this.backendService.fetchdropdownReplenishmentType(request).subscribe((res: any) => {
      this.dataService.strategyDropDownValues = res;
      this.dataService.strategyDropDownValues.unshift({ key: '', value: 'Select' });
    });
  }

  public viewReplenishment(type, i) {
    // LFWM-2439- The logic is moved to service side.
    // const arrayToBypassAllValue: Array<string> = ['ALL', 'all', '*'];
    // const zone2value = this.dataService.primaryDataMap['zone2'].cVal;
    // if (arrayToBypassAllValue.indexOf(zone2value) > -1) {
    //   this.dataService.primaryDataMap['zone2'].cVal = '';
    // }
    const searchCriteria = this.dataEditor.createDefaultSearchCriteriaforEdit(type);
    this.dataService.tabbedSearchServices[i].setSearchCriteria(searchCriteria);
    // const searchService: any = this.dataService.getDetailsSearchService();
    this.dataService.searchService = this.dataService.tabbedSearchServices[i];
    this.dataService.tabbedSearchServices[i].fetchSearchResults().subscribe((response: any) => {
      const rowLength = response['replenishResponse']['pageData']['rows'].length ? response['replenishResponse']['pageData']['rows'].length : '';
      const warnNoRowMessage = 'msg_no_row_view_inv-replensih';
      // the message needs to be displayed only for first tab
      if ((!rowLength || (rowLength < 1)) && (i === 0)) {
        this.alertService.clearAll().warn(this.resourceService.get(warnNoRowMessage));
      }
      this.dataService.getDetailsSearchStatus().hasResults = true;
      this.dataService.getDetailsSearchStatus().recordCount
        = this.dataService.getDetailsSearchService().getPagedData().pageDefinition.recordCount;
      const event = new SearchEvent(NEW_SEARCH_EVENT);
      event.isSearchSuccess = true;
      this.dataService.tabbedSearchServices[i].publishEvent(event);
      this.dataService.entityConfig.showDetailLineItems = true;
      // this.dataService.getDetailsSearchService().setDisplayMode('E');
      // this.dataService.displayMode = 'E';
      const pageRows = this.dataService.tabbedSearchServices[i].getPagedData().pageRows;
      this.dataEditor.populateRestrictedValues(pageRows, 'lot');
      this.dataEditor.populateRestrictedValues(pageRows, 'fromLoc');
      this.dataEditor.populateRestrictedValues(pageRows, 'id');
      // this.dataService.searchService = searchService;
    });
  }
  /**
    * replenishStart() is the button action for start button
    */
  public replenishStart() {
    const datamap = this.dataService.primaryDataMap;
    let report: any;
    if (datamap.facility.cVal) {
      if (datamap.replenType.cVal) {








        report = this.dataService.strategyDropDownValues.filter((strategy: any) => {
          return strategy.key === datamap.replenType.cVal;
        })
          .map((strategy: any) => {
            return strategy.value;
          });
        // [LFWM-2636-change added to handle the changes made in response structure]

        const ischeckPending: string = 'N';
        const warningNo: number = 0;
        this.backendService.replenishStart(datamap, ischeckPending, warningNo)
          .subscribe((resp: any) => {
            if (resp['statusCode'] && resp['statusMessage']) {
              if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {

                if (resp['warningNo'] !== 0 && resp['confirmMsg']) {
                  this.checkWarning(resp, ischeckPending, warningNo, report, datamap);
                } else {
                  const successKeyWord = '' + report + ' report from drop down is success';
                  this.alertService.clearAll();
                  this.alertService.success(successKeyWord);
                }
              } else if (resp['statusCode'] === 500) {
                this.alertService.clearAll();
                this.alertService.error(this.resourceService.translateServerResponse(resp['statusMessage']));
              }
            } else {
              if (resp.error) {
                this.alertService.clearAll();
                this.alertService.error(this.resourceService.translateServerResponse(resp.error));
              }
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
          });

      } else {
        this.alertService.clearAll().error(this.resourceService.get('msg_err_select_rep_type'));
      }

    } else {
      this.alertService.clearAll().error(this.resourceService.get('msg_err_enter_facility'));
    }
  }

  // LFWM-2636-added a recurressive function to handle warningNo
  public checkWarning(resp, ischeckPending, warningNo, report, datamap) {
    const dialog = resp['confirmMsg'];
    this.confirmDialogService.confirmDialog(dialog)
      .subscribe((isConfirmed: any) => {
        if (isConfirmed) {
          ischeckPending = 'Y';
          warningNo = resp['warningNo'];
          this.backendService.replenishStart(datamap, ischeckPending, warningNo)
            .subscribe((respaftrchkpndng: any) => {
              if (respaftrchkpndng['statusCode'] && respaftrchkpndng['statusMessage']) {
                if (respaftrchkpndng['statusCode'] === 200 && respaftrchkpndng['statusMessage'] === 'SUCCESS') {
                  if (warningNo === respaftrchkpndng['warningNo']) {
                    const successMessage = '' + report + ' ' + this.resourceService.get('msg_save_report_succes');
                    this.alertService.clearAll();
                    this.alertService.success(successMessage);

                  } else {
                    this.checkWarning(respaftrchkpndng, ischeckPending, respaftrchkpndng['warningNo'], report, datamap);
                  }
                } else if (respaftrchkpndng['statusCode'] === 500) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.translateServerResponse(respaftrchkpndng['statusMessage']));
                }
              } else {
                if (respaftrchkpndng.error) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.translateServerResponse(respaftrchkpndng.error));
                }
              }
            }, (error) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
            });
        }
      });
  }

  public ProceedWithWarningconfrimReplenshiment(confirmMsg, datamap, searchCriteria, proceedWithWarning) {
    this.confirmDialogService.confirmDialog(confirmMsg)
      .subscribe((isConfirmed: any) => {
        if (isConfirmed) {
          this.backendService.confirmStartedReplenisnment(datamap, searchCriteria, proceedWithWarning)
            .subscribe((resp: any) => {
              if (resp['statusCode'] && resp['statusMessage']) {
                if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                  // reload the search page
                  this.alertService.clearAll();
                  this.alertService.success(this.resourceService.get(this.successMsg));
                  this.navService.preventNavigation = false;
                  this.navService.removeLastBreadCrumbItem();
                  this.navService.retainAlerts().navigateByUrl(this.dataService.getEntityConfiguration().getSearchPageRoute());
                } else if (resp['statusCode'] === 500) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.translateServerResponse(resp['statusMessage']));
                }
              } else {
                if (resp.error) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.translateServerResponse(resp.error));
                }
              }
            }, (error) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
            });
        }
      });
  }

  // The task is under hold awaiting confirmation
  public releaseTaskReplenishment() {
    const zoneFields: Array<string> = [
      'zone2', 'zone3', 'zone4', 'zone5', 'zone6', 'zone7', 'zone8', 'zone9', 'zone10', 'zone11', 'zone12'
    ];
    // LFWM-2870-Made Changes in request format.
    const request: any = {
      'facility': this.dataService.primaryDataMap['facility'].cVal,
      'replenishStrategyKey': this.dataService.primaryDataMap['replenType'].cVal,
      'replGroup': this.dataService.primaryDataMap['replenishGroup'].cVal
    };

    Object.keys(this.dataService.primaryDataMap)
      .forEach((key: string) => {
        if (zoneFields.indexOf(key) > -1) {
          request[this.dataService.primaryDataMap[key].cName] = this.dataService.primaryDataMap[key].cVal;
        }
      });
    request['storerKey'] = this.dataService.primaryDataMap['storerKey'].cVal;
    this.backendService.releaseReplenishTask(request)
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            // reload the search page
            this.alertService.clearAll().success(this.successMsg);
          } else if (resp['statusCode'] === 500) {
            this.errorMsg = resp['statusMessage'];
            this.alertService.clearAll().error(this.resourceService.translateServerResponse(this.errorMsg));
          }
        } else {
          if (resp.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.get(resp.error));
          }
        }
      }, (error: any) => {
        this.alertService.clearAll().error(this.resourceService.get(error));
      });
  }



  /* the call is made from inv-replenishment static-form page and button Service,
  Since there are two post buttons one at detail level and another at page level */
  public postReplenishment(replenishKeys: Array<string>, isFromStatic?: boolean) {
    this.dialogMsg = 'msg_post_confirm';
    this.successMsg = 'msg_post_success';
    const datamap = this.dataService.primaryDataMap;
      if (datamap.facility.cVal) {
        if (isFromStatic) {
          this.postRePlenishmentConfirmed(replenishKeys);
        } else {
          if (this.dataService.tabbedSearchServices[0].getPagedData().pageRows.length > 0) {
            this.confirmDialogService.confirmDialog(this.resourceService.get(this.dialogMsg))
              .subscribe((isConfirmed: any) => {
                if (isConfirmed) {
                  let pageRows = this.dataService.tabbedSearchServices[0].getPagedData().pageRows;
                  replenishKeys = pageRows.map(el => { return el['cells']['replenishKey'].cVal});
                  this.postRePlenishmentConfirmed(replenishKeys);
                }
              });
          }
        }
      } else {
        this.alertService.clearAll().error(this.resourceService.get('msg_err_enter_facility'));
      }
  }
  public postRePlenishmentConfirmed(replenishKeys: Array<string>) {
    const datamap = this.dataService.primaryDataMap;
    let proceedWithWarning = 'N';
    this.backendService.postReplenisnment(replenishKeys)
      .subscribe((resp: any) => {
        if (resp['statusCode'] && resp['statusMessage']) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            // reload the search page
            this.alertService.clearAll();
            this.alertService.success(this.resourceService.get(this.successMsg));
            this.navService.preventNavigation = false;
            this.navService.removeLastBreadCrumbItem();
            this.navService.retainAlerts().navigateByUrl(this.dataService.getEntityConfiguration().getSearchPageRoute());
            this.dataService.tabbedSearchServices[0].performSearch();
          } else if (resp['statusCode'] === 500) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp['statusMessage']));
          } else if (resp['confirmMsg']) {
            proceedWithWarning = 'Y';
            this.ProceedWithWarningconfrimReplenshiment(resp['confirmMsg'], datamap,
              this.dataService.tabbedSearchServices[0].getSearchCriteria(), proceedWithWarning);
          }
        } else {
          if (resp.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp.error));
          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
  }
  public deleteDetail(replenishKeys) {

    this.successMsg = this.resourceService.get('msg_del_succ');

    this.backendService.deleteAllDetails(replenishKeys).subscribe((resp: any) => {
      if (resp['statusCode'] && resp['statusMessage']) {
        if (resp['statusCode'] === 200) {
          this.dataService.tabbedSearchServices[0].performSearch();
          this.alertService.clearAll().success(this.resourceService.get(this.successMsg));
        }
      } else {
        if (resp.error) {
          this.alertService.clearAll();
          this.alertService.error(this.resourceService.translateServerResponse(resp.error));
        }
      }
    }, (error: any) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });
  }

  public saveAfterEdit() {
    const editedLineItems: any = this.dataService.tabbedSearchServices[0].getEditedRows();
    if (editedLineItems.length === 0) {
      this.alertService.clearAll().warn(this.resourceService.get('msg_no_mod'));
      this.dataService.displayMode = 'V';
      return false;
    }
    const editedCells: Array<any> = [];
    editedLineItems.forEach((row: any) => {
      for (const property in row.cells) {
        if (row.cells[property].cName === 'cases' || row.cells[property].cName === 'eaches') {
          if (parseFloat(row.cells[property].cVal) !== parseFloat(row.cells[property].cValOrig)) {
            editedCells.push(row.cells[property]);
          }
        } else {
          if (row.cells[property].cVal !== row.cells[property].cValOrig) {
            editedCells.push(row.cells[property]);
          }
        }
      }
    });
    if (editedCells.length === 0) {
      this.alertService.clearAll().warn(this.resourceService.get('msg_no_mod'));
      this.dataService.displayMode = 'V';
      return false;
    }
    const requestArray: Array<any> = [];
    editedLineItems.map((row: any) => {
      const request = {
        'replenishKey': row.cells['replenishKey'].cVal ? row.cells['replenishKey'].cVal : row.cells['replenishKey'].cValOrig,
        'fromLoc': row.cells['fromLoc'].cVal ? row.cells['fromLoc'].cVal : row.cells['fromLoc'].cValOrig,
        'lot': row.cells['lot'].cVal ? row.cells['lot'].cVal : row.cells['lot'].cValOrig,
        'id': row.cells['id'].cVal ? row.cells['id'].cVal : row.cells['id'].cValOrig,
        'qty': row.cells['total'].cVal = Number(row.cells['total'].cVal),

      };
      requestArray.push(request);
    });
    this.backendService.saveAfterEdit(requestArray).subscribe((resp: any) => {
      if (resp['statusCode'] && resp['statusMessage']) {
        if (resp['statusCode'] === 200) {
          this.dataService.tabbedSearchServices[0].performSearch();
          const succesMessage = 'msg_save_succ';
          this.alertService.clearAll().success(this.resourceService.get(succesMessage));
        }
      } else {
        if (resp.error) {
          this.alertService.clearAll();
          this.alertService.error(this.resourceService.translateServerResponse(resp.error));
        }
      }
    }, (error: any) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      this.dataService.displayMode = 'E';
    }

    );
  }

  // LFWM-3641- overriding this function as we are using facility as documentId.
  public handlingDynamicButtonAction(action: string) {
    const currentButtonInfo = this.buttonService.dynamicButtons.filter(button =>
      button.staticButtonName.toUpperCase() === action.toUpperCase());
    const confirmationMsg = currentButtonInfo[0]['confirmationMsg'] ? currentButtonInfo[0]['confirmationMsg'] :
      this.resourceService.get('genric_confirm_msg');
    this.confirmDialogService.confirmDialog(confirmationMsg)
      .subscribe((isConfirmed: any) => {
        if (isConfirmed) {
          const storerKey = this.dataService.primaryDataMap['storerKey'].cVal;
          const documentKey = this.dataService.primaryDataMap['facility'].cVal;
          const moduleName = this.dataService.tableIdToModuleNameMapping[this.dataService.primarySearchParams.tableId];
          const actionCode = currentButtonInfo[0]['code'];
          const screenType = action;
          const tableId = this.dataService.primarySearchParams.tableId;
          this.backendService.handlingDynamicButtonAction(storerKey, documentKey, moduleName, actionCode, tableId, screenType).subscribe((resp: any) => {
            if (resp.statusCode === 200 && resp.statusMessage === 'SUCCESS') {
              this.alertService.clearAll();
              this.alertService.success(this.dataService.createAlertMessage(this.resourceService.get('msg_activity_suc'), currentButtonInfo[0]['buttonName']));
              this.dataService.setDisplayMode('V');
              this.buttonService.initializeSearchPageButtons();
              this.clearEditedFlags();
              this.navService.preventNavigation = false;
            } else {
              if (resp.errMsg) {
                this.alertService.clearAll().error(this.resourceService.translateServerResponse(resp.errMsg));
              }
            }
          }, (error) => {
            this.alertService.clearAll().error(this.resourceService.get(error));
          });
        }
      });
  }

  public deleteAllLineitems() {
    this.successMsg = this.resourceService.get('msg_del_succ');
    const pageInfoReq = {
      "tableId": "invreplenishtd",
      "pageNo": 1,
      "sortColumn": null,
      "sortOrder": 0,
      "pageSize": 10,
      "fullFetch": true,
      "fetchAllrecords": true
    };
    const payload = {
      pageInfo: pageInfoReq,
      searchCriteria: this.dataService.searchService.formatSearchCriteria(this.dataService.searchService.getSearchCriteria(), this.dataService.searchService.searchParams.additionalParamMap)
    };
    this.backendService.deleteAllLineitems(payload).subscribe((resp: any) => {
      if (resp['statusCode'] && resp['statusMessage']) {
        if (resp['statusCode'] === 200) {
          this.dataService.tabbedSearchServices[0].performSearch();
          this.alertService.clearAll().success(this.resourceService.get(this.successMsg));
        }
      } else {
        if (resp.error) {
          this.alertService.clearAll();
          this.alertService.error(this.resourceService.translateServerResponse(resp.error));
        }
      }
    }, (error: any) => {
      this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
    });
  }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/inventory-replenish/services/inventory-replenish-action.service.ts